import { useModal } from '@starsoft/common/hooks';
import TransactionsLayout from '../../Layout';
import TransactionModalsWithdrawContentLayout from './Layout';
import TransactionModalsWithdrawContent from './Content';
import { CommonModalsKey } from '@starsoft/common/enums';
import { TransactionModalWithdrawProps } from './props';

/**
 * TransactionModalWithdraw Component
 * Renders a modal for handling withdrawal transactions. Uses a common transaction layout
 * and wraps withdrawal-specific content components.
 *
 * The component uses the useModal hook to handle modal state and callbacks for the withdrawal modal.
 *
 * @component
 * @returns {JSX.Element} A modal component with withdrawal transaction content
 *
 * @example
 * // The component is typically used in a modal context:
 * <TransactionModalWithdraw />
 *
 * // The useModal hook returns callbacks like:
 * const modalCallbacks = {
 *   onClose: () => void,
 *   onBack: () => void,
 *   isOpen: boolean
 * }
 */
export function TransactionModalWithdraw({
  originId,
  version,
}: TransactionModalWithdrawProps) {
  const modalCallbacks = useModal(CommonModalsKey.Withdraw);

  return (
    <TransactionsLayout modalCallbacks={modalCallbacks} version={version}>
      <TransactionModalsWithdrawContentLayout
        originId={originId}
        version={version}
      >
        <TransactionModalsWithdrawContent />
      </TransactionModalsWithdrawContentLayout>
    </TransactionsLayout>
  );
}
